import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Card, Group, Image, NumberFormatter, Progress, Text, rem } from '@mantine/core';
import classes from '../../Shares/Progress.module.css';
export const VipAchievementCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" p={{
    base: 10,
    sm: 20
  }} radius={5}>
      <Group gap={10} align="center">
        <Image src="/assets/profile/bronze.png" alt="rank" w={56} h={56} />
        <Box>
          <Text tt="uppercase" fz={{
          base: 14,
          sm: 18
        }} c="prime.11" className={gunterzBold.className}>
            {i18n._('Level 2')}
          </Text>
          <Text fz={13} fw={700} mt={-8} c="prime.14" tt="uppercase">
            {i18n._('Bronze')}
          </Text>
        </Box>
      </Group>

      <Box pt={30}>
        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--text-prime)" fw={700}>
            <NumberFormatter value={38577} thousandSeparator="," decimalSeparator="." />
          </Text>
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--icon-color)" fw={700}>
            <NumberFormatter value={50000} thousandSeparator="," decimalSeparator="." />
          </Text>
        </Group>

        <Box bg="dark.13" h={27} p={0} mt={10} style={{
        borderRadius: rem(5)
      }}>
          <Group h="100%" px={16}>
            <Box pos="relative" w="100%">
              <Box pos="absolute" style={{
              top: -40,
              left: `calc(${77}% - 2%)`
            }}>
                <Text fz={18} c="var(--text-prime)" className={gunterzBold.className}>
                  77%
                </Text>
              </Box>
              <Progress radius={0} size="md" value={77} striped classNames={{
              root: classes.root,
              section: classes.sectionOne
            }} style={{
              zIndex: 1
            }} />

              <Progress radius={0} size="md" value={100} striped classNames={{
              root: classes.root,
              section: classes.sectionSecond
            }} pos="absolute" inset={0} />
            </Box>
          </Group>
        </Box>

        <Group mt={10} justify="space-between">
          <Text c="var(--text-prime)" fz={{
          base: 12,
          sm: 13
        }} fw={700} tt="uppercase">
            {i18n._('LEVEL 2 (BRONZE)')}
          </Text>
          <Text c="var(--icon-color)" fz={{
          base: 12,
          sm: 13
        }} fw={700} tt="uppercase">
            {i18n._('NEXT: LEVEL 3')}
          </Text>
        </Group>
      </Box>
    </Card>;
};